import { Component, EventEmitter, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { StudentDetail } from './student-detail.model';
import { StudentDetailParentContact } from './student-detail-parent-contact.model';
import { StudentService } from '../../shared-components/student/student.service';
import { LoginSettings } from '../../shared-modules/login/loginSetting.model';
import { Year } from '../../shared-components/year/year.model';
import { Student } from '../../shared-components/student/student.model';
import { TylerMatTableDataSource } from '../../shared-components/angular-material/extended.class';
import { LoginService } from '../../shared-modules/login/login.service';
import { UserService } from '../../shared-components/user/user.service';
import { YearService } from '../../shared-components/year/year.service';
import { AriaDirective } from '../../shared-components/directives/aria.directive';
import { CdkDetailRowDirective } from '../../shared-components/directives/cdk-detail-row.directive';
import { Router } from '@angular/router';
import { SendEmailService } from '../../shared-modules/send-email/send-email.service';
import { User } from '../../shared-components/user/user.model';
import { detailExpand } from '../../shared-components/angular-material/mat-animations';
import { ViewStudentAddressComponent } from './view-student-address/view-student-address.component';
import * as _ from 'lodash';

@Component({
    selector: 'app-student-details',
    templateUrl: './student-details.component.html',
    animations: [
        detailExpand
    ],
    styleUrls: [
        './student-details.component.css'
    ]
})

export class StudentDetailsComponent implements OnInit, OnDestroy {
    V10: boolean;
    loginSettings: LoginSettings;
    student360YearSubscription: Subscription;
    student360Year: Year;
    selectedStudentSubscription: Subscription;
    selectedStudent: Student;
    studentDetails: StudentDetail = new StudentDetail();
    studentDetailIn: StudentDetail[] = [];
    displayParentContacts: StudentDetailParentContact[] = [];
    subscriptions: Subscription[] = [];
    rowExpanded: Array<boolean[]> = new Array<boolean[]>();
    toggleAllRows: EventEmitter<boolean> = new EventEmitter<boolean>();
    columnsToDisplay: string[] = ['More', 'Relationship', 'Name', 'EmergencyPhone', 'Homephone', 'Cellphone'];
    columnsToDisplayStudentDetail = ['Primary Parent', 'Email Address', 'Is Guardian', 'Lives With', 'Has Custody', 'Restricted', 'Place Of Work', 'Primary Address', 'Mailing Address', 'Work Phone', 'Student may leave with this person', 'Comment'];
    columnsToDisplayDetailRow: string[] = ['View'];
    parentType = ['Parent', 'Household', 'Nonresident', 'Emergency'];
    studentLoginHidden = true;
    studentPasswordHidden = true;
    lockerComboHidden = true;
    maskedLogin = '';
    maskedPassword = '';
    maskedLocker = '';
    isBusy: boolean;
    angularMatData = new TylerMatTableDataSource();
    @ViewChild(MatSort) sort: MatSort;
    row: any;
    currentUser: User;
    schools = [];

    constructor(
        private loginService: LoginService,
        private router: Router,
        private studentService: StudentService,
        private userService: UserService,
        private yearService: YearService,
        private sendEmailService: SendEmailService,
        private dialog: MatDialog
    ) {
        this.selectedStudentSubscription = studentService.selectedStudentStream$.subscribe(
            studentId => {
                this.loadStudentInfo(studentId);
            });
        this.student360YearSubscription = yearService.observableStudent360YearStream$.subscribe(
            student360Year => {
                this.getStudentDetails();
            }
        );
        this.loginSettings = this.loginService.LoginSettings;
        this.angularMatData = new TylerMatTableDataSource(this.displayParentContacts);
    }

    loadStudentInfo(studentId: number) {
        this.selectedStudent = this.studentService.students.filter(function (student) { return student.Id == studentId; })[0];
        this.getStudentDetails();
    }

    ngOnInit() {
        this.V10 = this.loginService.LoginSettings.V10;
        this.currentUser = this.userService.currentUser;
        if (this.currentUser.UserType == 1) {
            if (this.V10) {
                this.columnsToDisplay = ['More', 'PrimaryParent', 'CallSequence', 'Relationship', 'Name', 'EmergencyPhone', 'Homephone', 'Cellphone', 'PortalAccess', 'LastAccess'];
            }
            else {
                this.columnsToDisplay = ['More', 'Relationship', 'Name', 'EmergencyPhone', 'Homephone', 'Cellphone', 'PortalAccess', 'LastAccess'];
            }
        }
        this.subscriptions.push(
            this.toggleAllRows.subscribe(toggle => {
                for (let i = 0; i < this.parentType.length; i++) {
                    for (let j = 0; j < this.rowExpanded[i].length; j++) {
                        this.rowExpanded[i][j] = toggle;
                    }
                }

            })
        );

        if (!this.loginSettings.DisplayEmergencyPhoneNumberInGrid) {
            if (this.currentUser.UserType == 1) {
                this.columnsToDisplay = ['More', 'Relationship', 'Name', 'Homephone', 'Cellphone', 'PortalAccess', 'LastAccess'];
            }
        }
    }

    ngOnDestroy() {
        this.selectedStudentSubscription.unsubscribe();
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }

    getStudentDetails() {
        const yearId = (this.userService.currentUser.UserType != 1) ? this.yearService.allYears.filter(y => y.Default)[0].Id : this.yearService.student360Year.Id;
        this.subscriptions.push(
            this.studentService.getStudentDetails(this.selectedStudent.Id, yearId, this.userService.userId).subscribe(detail => {
                if (detail != null) {
                    this.studentDetails = detail;
                    this.displayParentContacts = this.studentDetails.StudentParentContacts;
                    this.loadStudenDetails();
                    for (let i = 0; i < this.parentType.length; i++) {
                        const arr: Array<boolean> = [];
                        for (let j = 0; j < this.displayParentContacts.filter(contact => contact.ParentType == this.parentType[i]).length; j++) {
                            arr.push(false);
                        }
                        this.rowExpanded.push(arr);
                    }
                    if (this.studentDetails.ShowStudentLogin) {
                        this.maskedLogin = '';
                        for (let i = 0; i < this.studentDetails.StudentLogin.length; i++) {
                            this.maskedLogin = this.maskedLogin + '*';
                        }
                    }
                    if (this.studentDetails.ShowStudentPassword) {
                        this.maskedPassword = '';
                        for (let i = 0; i < this.studentDetails.StudentPassword.length; i++) {
                            this.maskedPassword = this.maskedPassword + '*';
                        }
                    }
                    if (this.studentDetails.LockerCombination != null) {
                        this.maskedLocker = '';
                        for (let i = 0; i < this.studentDetails.LockerCombination.length; i++) {
                            this.maskedLocker = this.maskedLocker + '*';
                        }
                    }

                    this.schools = this.studentDetails.DualEnrolled.split(',');
                }
            })
        );
    }

    private loadStudenDetails(): void {
        this.angularMatData = new TylerMatTableDataSource(this.displayParentContacts);
        setTimeout(() => {
            this.angularMatData.sort = this.sort;
        }, 0);

        this.isBusy = false;
    }

    onToggleChange(cdkDetailRow: CdkDetailRowDirective): void {
        if (cdkDetailRow.row.AttendanceDetails != undefined && cdkDetailRow.row.AttendanceDetails.length == 0 && cdkDetailRow.expended) {
            cdkDetailRow.toggle();
        }
    }

    getAriaDetailRow(row: StudentDetailParentContact): string {
        const colList: string[] = ['Relationship',
            'Name',
            'Homephone',
            'EmergencyPhone',
            'Cellphone'];

        const dataList: string[] = [row.Relationship,
        row.Name,
        row.EmergencyPhone,
        row.Homephone,
        row.Cellphone];

        return AriaDirective.concatAriaStrings(colList, dataList);
    }

    getAriaStudentDetail(row: StudentDetailParentContact): string {
        const colList: string[] = ['Primary Parent',
            'Email Address',
            'Is Guardian',
            'Lives With',
            'Has Custody',
            'Restricted',
            'Place Of Work',
            'Primary Address',
            'Mailing Address',
            'Work Phone',
            'Student may leave with this person',
            'Comment'];

        const dataList: string[] = [row.PrimaryParent,
        row.EmailAddress,
        row.IsGuardian,
        row.LivesWith,
        row.HasCustody,
        row.Restricted,
        row.PlaceOfWork,
        row.PrimaryAddress,
        row.MailingAddress,
        row.EmergencyPhone,
        row.ECLeaveWithThisPerson,
        row.ECComments];

        return AriaDirective.concatAriaStrings(colList, dataList);
    }

    hasParentContacts(parentType: string): boolean {
        return this.displayParentContacts.filter(contact => contact.ParentType == parentType).length > 0;
    }

    getParentContactTableData(parentType: string): StudentDetailParentContact[] {
        return this.displayParentContacts.filter(contact => contact.ParentType == parentType);
    }

    toggleMore(row: any) {
        this.angularMatData.toggleExpanded(row);
    }

    checkExpanded(row: any): boolean {
        return this.angularMatData.checkExpanded(row);
    }

    expandAll(expand: boolean) {
        this.angularMatData.expandAll(expand);
    }

    sendEmail(name: string, emailAddress: string) {
        this.sendEmailService.teacherEmailAddress = emailAddress;
        this.sendEmailService.teacherName = name;
        this.router.navigateByUrl('/student360/sendEmail');
    }

    viewStudentAddress() {
        let viewAddressDialog = this.dialog.open(ViewStudentAddressComponent, { panelClass: 'tyl-mat-dialog', disableClose: true });
        viewAddressDialog.componentInstance.studentId = this.selectedStudent.Id;
    }

}